import { GeneOutlierFilterOption } from '../types';
import { GeneOutlier } from '../../components';
import { externalSourceReferenceOption as sourceReferenceOption } from '../../../../../../src/components/common/Genomics/ExternalSourceOptions';

export const config: GeneOutlierFilterOption = {
  id: 'omicsExplorer.filters.geneOutlier',
  title: {
    id: 'omicsExplorer.filters.geneOutlier',
    defaultMessage: 'Outliers',
  },
  content: GeneOutlier,
  injectedProps: {
    searchKey: 'outlierStdDev',
    geneOutlierOption: {
      id: 'omicsExplorer.filters.geneOutlier',
      helperTextLabel: {
        id: 'omicsExplorer.filters.geneOutlier.helperTextLabel',
        defaultMessage: '# of std deviations',
      },
      over_avg: {
        id: 'omicsExplorer.filters.geneOutlier.over_avg',
        defaultMessage: '{stdDev} s.d. above mean',
      },
      under_avg: {
        id: 'omicsExplorer.filters.geneOutlier.under_avg',
        defaultMessage: '{stdDev} s.d. below mean',
      },
      over_median: {
        id: 'omicsExplorer.filters.geneOutlier.over_median',
        defaultMessage: '{stdDev} s.d. over median',
      },
      under_median: {
        id: 'omicsExplorer.filters.geneOutlier.under_median',
        defaultMessage: '{stdDev} s.d. under median',
      },
      tooltipTitle: {
        id: 'omicsExplorer.filters.geneOutlier.tooltipTitle',
        defaultMessage: '{source}:{sourceReference}:{outlier}',
      },
    },
    sourceReferenceOption,
  },
};
